import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'hfc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  @Input()
  public type: 'primary' | 'secondary' | 'tertiary' | 'red' | 'outline' | 'transparent' | 'grey';

  @Input()
  public submit = false;

  @Input()
  public size: 'large' | 'normal' | 'small' | 'extra-small' = 'normal';

  @Input()
  public icon: string;

  @Input()
  public postfixIcon: string;

  @Input()
  public disabled: boolean;

  @Input()
  public isLoading = false;

  constructor() {}

  @HostBinding('style.pointer-events')
  public get pointerEvents() {
    return this.disabled || this.isLoading ? 'none' : 'auto';
  }

  public getButtonClasses() {
    return {
      'button-primary': this.type === 'primary',
      'button-secondary': this.type === 'secondary',
      'button-tertiary': this.type === 'tertiary',
      'button-grey': this.type === 'grey',
      'button-red': this.type === 'red',
      'button-outline': this.type === 'outline',
      'btn-clear': this.type === 'transparent',

      'btn-lg': this.size === 'large',
      'btn-md': this.size === 'normal',
      'btn-sm': this.size === 'small',
      'btn-xs': this.size === 'extra-small'
    };
  }
}
